import { ConnectAppleButton } from 'react_components/connect_apple_button';
import { ConnectGoogleButton } from 'react_components/connect_google_button';
import { ContributeTrailApp } from 'react_components/contribute/contribute_trail_app';
import { Converter } from 'react_components/converter/converter';
import { ConverterSuccess } from 'react_components/converter/converter_success';
import { FullscreenMapElevationPane } from 'react_components/search/fullscreen/FullscreenMapElevationPane';
import { lazy } from 'react';
import { LifelineSearchInterface } from 'react_components/admin/lifeline_search_interface';
import { LocationMergeInterface } from 'react_components/admin/location_merge_interface';
import enableMobileRoadblock from 'utils/enableMobileRoadblock';
import { PhotoAdminTool } from 'react_components/admin/photo_admin_tool';
import { PhotoForTrailOrTrack } from 'react_components/photos/photo_for_trail_or_track';
import ProfileEditForm  from 'components/forms/ProfileEditForm';
import { StatusUpdateResults } from 'react_components/status_update/status_update_results';
import { TranslationEditInterface } from 'react_components/admin/translation_edit_interface';
import { UserStatsDashboard } from 'react_components/stats/user_stats_dashboard';
import About from 'pages/About';
import AccountMergeInterface from 'components/admin/AccountMergeInterface';
import AcquiredContentInterface from 'components/admin/AcquiredContentInterface';
import AlgoliaSearchBoxErbWrapper from 'components/AlgoliaSearchBox/AlgoliaSearchBoxErbWrapper';
import AutoRenewal from 'components/AutoRenewal';
import AccountLinks from 'components/profile/AccountLinks';
import AvatarStackContainer from 'components/profile/AvatarStackContainer';
import BannerManager from 'components/admin/BannerManager';
import BulkTrailEdit from '../pages/BulkTrailEdit';
import Careers from 'pages/Careers';
import CommunityApp from '../microapps/Community/Feed';
import CouponManager from 'components/admin/CouponManager';
import CreateListPopupButton from 'components/profile/CreateListPopupButton';
import DeleteRecording from 'components/DeleteRecording';
import FacebookSettings from 'components/FacebookSettings';
import FiveHundred from 'pages/errors/FiveHundred';
import FooterWrapper from 'components/FooterWrapper';
import ForgotPassword from 'pages/ForgotPassword';
import FourOFour from 'pages/errors/FourOFour';
import GeneralPrivacyPolicy from 'components/privacyPolicy/GeneralPrivacyPolicy';
import GlobalActions from 'components/GlobalActions';
import ListContainer from 'components/ListContainer';
import MemberSearchBoxContainer from 'components/forms/MemberSearchBoxContainer';
import NavigationWrapper from 'components/NavigationWrapper';
import NotificationsSettings from 'components/NotificationsSettings';
import ResetPassword from 'pages/ResetPassword';
import PhotoForTrailOrTrackCollection from 'components/profile/PhotoForTrailOrTrackCollection';
import PrintPage from 'components/PrintPage';
import ProfileSidebar from 'components/profile/ProfileSidebar';
import ProfileSlidingTabs from 'components/profile/ProfileSlidingTabs';
import ProStatus from 'components/ProStatus';
import QuoteRotator from 'components/QuoteRotator';
import RecordingSearchInterface from 'components/admin/RecordingSearchInterface';
import ReferralRouter from 'components/ReferralRouter';
import Refer from 'components/Refer';
import RemoteLightbox from 'components/shared/RemoteLightbox';
import ReviewsUgcWrapper from 'components/trailUgc/ReviewsUgcWrapper';
import SearchApp from 'components/SearchApp';
import SidebarTrailResultListWrapper from 'components/SidebarTrailResultListWrapper';
import SocialButtonGroup from 'components/community/SocialButtonGroup';
import UserListItem from 'components/UserListItem';
import UserAvatar from 'components/profile/UserAvatar';
import UserProfileHeader from 'components/profile/UserProfileHeader';
import UserEmptyReviews from 'components/profile/UserEmptyReviews';
import Welcome from 'pages/Welcome';
import withSuspense from '../hocs/withSuspense';

const CookiePolicy = lazy(() => import('pages/CookiePolicy/CookiePolicyCSR'));
const PortalApp = lazy(() => import('../microapps/Portal'));
const PrivacyPolicy = lazy(() => import('pages/PrivacyPolicy/PrivacyPolicyCSR'));
const Terms = lazy(() => import('pages/Terms/TermsCSR'));

require('@alltrails/maps/sharedCss.css');
require('@alltrails/shared/sharedCss.css');

const ReactRailsUJS = require('react_ujs');

const context = {
  About,
  AccountMergeInterface,
  AcquiredContentInterface,
  AccountLinks,
  AvatarStackContainer,
  MemberSearchBoxContainer,
  AlgoliaSearchBoxErbWrapper,
  AutoRenewal,
  BannerManager,
  BulkTrailEdit,
  Careers,
  CookiePolicy: withSuspense(CookiePolicy, 'CookiePolicy'),
  CommunityApp,
  ConnectAppleButton,
  ConnectGoogleButton,
  ContributeTrailApp,
  Converter,
  ConverterSuccess,
  CouponManager,
  CreateListPopupButton,
  DeleteRecording,
  FacebookSettings,
  FiveHundred,
  FooterWrapper,
  ForgotPassword,
  FourOFour,
  FullscreenMapElevationPane,
  GeneralPrivacyPolicy,
  GlobalActions,
  LifelineSearchInterface,
  ListContainer,
  LocationMergeInterface,
  NavigationWrapper,
  NotificationsSettings,
  ResetPassword,
  PhotoAdminTool,
  PhotoForTrailOrTrack,
  PhotoForTrailOrTrackCollection,
  PortalApp: withSuspense(PortalApp, 'PortalApp'),
  PrintPage,
  PrivacyPolicy: withSuspense(PrivacyPolicy, 'PrivacyPolicy'),
  ProfileEditForm,
  ProfileSidebar,
  ProfileSlidingTabs,
  QuoteRotator,
  RecordingSearchInterface,
  ReferralRouter,
  Refer,
  RemoteLightbox,
  ProStatus,
  ReviewsUgcWrapper,
  SearchApp,
  SidebarTrailResultListWrapper,
  SocialButtonGroup,
  StatusUpdateResults,
  Terms: withSuspense(Terms, 'Terms'),
  TranslationEditInterface,
  UserListItem,
  UserAvatar,
  UserProfileHeader,
  UserEmptyReviews,
  UserStatsDashboard,
  Welcome
};

ReactRailsUJS.getConstructor = className => context[className];

enableMobileRoadblock();
